__webpack_require__.p = "https://insight.affinity.io/";